/*
 * @Author: M.D.
 * @Date: 2020-01-10 13:39:18
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
// import _ from 'lodash'

export default {
  // 获取广告列表
  fetchADs: (no = 5) => {
    return request({
      url: `/base/pc/advertisement/list/${no}`,
      method: 'get'
    })
  },

  // 最新资讯
  fetchLatestNews: () => {
    return request({
      url: '/base/pc/consultancy/new',
      method: 'get'
    })
  },

  // 获取最新培训
  fetchLatestTrain: params => {
    return request({
      url: '/order/home/getTrainList',
      method: 'get',
      params
    })
  },

  // 获取推荐商品
  fetchRecmdGoods: params => {
    return request({
      url: '/order/home/getRecommendList',
      method: 'get',
      params
    })
  }
}
